// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0_@swc+core@1.7.1_@swc+helpers@0.5.5__/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0_@swc+core@1.7.1_@swc+helpers@0.5.5__/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J5f9KLlATUtxW7uUW2sn{display:inline-flex;align-items:center;gap:4px}`, "",{"version":3,"sources":["webpack://./src/domains/MemberRegistration/RegistrationInfoCard/CustomFieldsForm/CustomFieldsForm.module.scss"],"names":[],"mappings":"AAEA,sBACE,mBAAA,CACA,kBAAA,CACA,OAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fileName": `J5f9KLlATUtxW7uUW2sn`
};
export default ___CSS_LOADER_EXPORT___;
